import { Skeleton } from '@aloft/toolkit-sui/chakra';

import { CSSProperties, useState } from 'react';

type SimpleImageProps = {
  url: string;
  alt?: string;
  style?: CSSProperties;
};

export const SimpleImage = ({ url, alt, style }: SimpleImageProps) => {
  const [loading, setLoading] = useState(true);
  if (!url) return null;

  return (
    <Skeleton
      isLoaded={!loading}
      height="100%"
      width="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <img
        src={url}
        alt={alt ?? 'house'}
        onLoad={() => setLoading(false)}
        style={{ maxWidth: '100%', maxHeight: '100%', ...style }}
      />
    </Skeleton>
  );
};
